import { FunctionalComponent, h } from '@stencil/core';
import { FluidI18nStore } from '../components';
import { FluidTheme } from '@lmig/fluid-core';
import { FluidFunctionalComponentProps } from '../model/functional/fluid-functional-component-props.interface';

export interface FluidChartTranslationOptions {
  chartTitle?: string;
  subTitle?: string;
}

interface ChartHeadingProps extends FluidFunctionalComponentProps {
  title?: string;
  subTitle?: string;
  i18nStore?: FluidI18nStore;
  fluidTranslate?: FluidChartTranslationOptions;
  fontSize?: number;
  theme: FluidTheme;
}

interface ChartLegendMarkerProps extends FluidFunctionalComponentProps {
  size: number;
  color: string;
}

// ================================================================ //
// -- Public Functional Components

/**
 * Chart Title
 */
export const ChartTitle: FunctionalComponent<ChartHeadingProps> = (
  props: ChartHeadingProps
) => {
  const { title, i18nStore, fluidTranslate, fontSize, theme } = props;
  const fontSizeStyle = !!fontSize && { fontSize: `${fontSize}px` };

  return (
    !!title && (
      <fluid-title
        class='title-container'
        level='1'
        disableGutters={true}
        theme={theme}
        overrideGlobalTheme={true}>
        <span style={fontSizeStyle}>
          {i18nStore?.translate(fluidTranslate?.chartTitle) || title}
        </span>
      </fluid-title>
    )
  );
};

/**
 * Chart Subtitle
 */
export const ChartSubtitle: FunctionalComponent<ChartHeadingProps> = (
  props: ChartHeadingProps
) => {
  const { subTitle, i18nStore, fluidTranslate, fontSize, theme } = props;
  const fontSizeStyle = !!fontSize && { fontSize: `${fontSize}px` };

  return (
    !!subTitle && (
      <fluid-title
        class='subtitle-container'
        level='2'
        disableGutters={true}
        theme={theme}
        overrideGlobalTheme={true}>
        <span style={fontSizeStyle}>
          {i18nStore?.translate(fluidTranslate?.subTitle) || subTitle}
        </span>
      </fluid-title>
    )
  );
};

/**
 * Color swatch for chart legend item
 */
export const ChartLegendMarker: FunctionalComponent<ChartLegendMarkerProps> = (
  props: ChartLegendMarkerProps
) => {
  const { size, color } = props;
  return (
    <svg width={size} height={size}>
      <rect width={size} height={size} x='0' y='0' rx='4' ry='4' fill={color} />
    </svg>
  );
};
